<template>
  <div
    class="list_one"
    :key="i"
    :style="{
    padding:pc_infor.padding[pc_infor.padding.radio_val].paddingTop/2 + 'px ' + pc_infor.padding[pc_infor.padding.radio_val].paddingLeft/2 + 'px',
    width:type === 'ordinary' ? 100 / infor.col_num[infor.col_num.radio_val].value + '%' : '100%',
    ...box_shadow
    }"
    data-comb-dom
    :data-col_num="infor.col_num[infor.col_num.radio_val].value"
    @mouseenter="module_isHover( true)"
    @mouseleave="module_isHover(false)"
  >
  <!-- ...box_shadow -->
    <div
      class="list_img_frame animationBox"
      ref="animationBox"
      @mouseenter="(e) => { templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern) }"
      @mouseleave="(e) => { templet.leave_animation(this.img_effects, e.target) }"
      :style="{ 
        paddingBottom: pc_infor.img_size[pc_infor.img_size.radio_val].height,        
        borderRadius: pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value + 'px'
      }"
    >
      <div
        class="list_img_back animationImg"
        :style="{
        backgroundImage:'url(' + item.img_path + ')',
        backgroundSize:pc_infor.backgroundSize.radio_val === 'default' ? pc_infor.backgroundSize.default.backgroundSize : pc_infor.backgroundSize.custom.backgroundSize
      }"
      ></div>
      <div class="my_photo_desc" v-if="item.summary && infor.alt_display == 'true'">
        <span class="wb-normal">{{item.summary}}</span>
      </div>

      <div
        class="tooptipPart one_img_tooptipPart"
        v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
        @click.stop
      >
        <my_hover_btn :tips="$t('widgets_basic_banner_index_439')" btnIcon="el-icon-edit" @changeStyle="edit_one"></my_hover_btn>
        <my_hover_btn :tips="$t('widgets_basic_banner_index_440')" btnIcon="el-icon-close" @changeStyle="del_one"></my_hover_btn>
      </div>
      <set_link class="linkPart" :sendData="item.intro"></set_link>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import {getBoxShadowStyle} from '@/utils/utils'
export default {
  name: "basic_list_photos_one_img",
  data() {
    return {
      isHover: false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    pc_infor: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    i: {
      type: Number,
      default: 0
    },
    infor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "ordinary"
    },
    imgs: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    source_item() {
      const list = (this.module.data.listArr.custom || []);
      return list.find(n => n.album_id && n.album_id === this.item.album_id) || this.item;
    },
    edit_one() {
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.item.img_path = e[0].filePath;
          this.source_item().img_path = e[0].filePath;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    },
    del_one() {
      const list = (this.module.data.listArr.custom || []);
      const source = list.find(n => n.album_id && n.album_id === this.item.album_id);
      if ((source ? list.length : this.imgs.length) <= 1) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_basic_banner_index_441')
        });
        return;
      }
      this.$confirm(i18n.t('widgets_basic_banner_index_442'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          if (source) {
            list.splice(list.indexOf(source), 1);
          } else {
            this.imgs.splice(this.i, 1);
          }
        })
        .catch(() => {});
    },
    module_isHover(val) {
      this.isHover = val
    }
  },
  computed: {
    img_effects() {
      return this.module.data.img_effects;
    },
    /* pc_infor () {
      return this.module.data.pc_widgets_infor
    }, */
    box_shadow(){ // 阴影设置 只有PC端才能有阴影 其他的不存在
      return this.$store.state.app.view_pattern === 'pc'?(this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover') :getBoxShadowStyle(this.pc_infor.boxShadow)):{}
    },
  },
  components: {},
  created() {},
  mounted() {
    this.templet.initImageAnimation(
      this.img_effects,
      this.img_effects,
      this.$refs.animationBox,
      this.$store.state.app.view_pattern
    );
  }
};
</script>

<style scoped lang="scss">
.basic_list_photos {
  .list_frame {
    .list_box {
      .list_one {
        background: none;
        position: relative;
        display: inline-block;
        overflow:hidden;
        // margin: 10px;
        .tooptipPart {
          right: 0;
          bottom: 0;
          top: auto;
          display: none;
          z-index: 999;
        }

        .list_img_frame {
          position: relative;
          overflow: hidden;
          .list_img_back {
            width: 100%;
            height: 100%;
            position: absolute;
            background-position: center center;
            -webkit-transition: all ease 0.36s;
            -o-transition: all ease 0.36s;
            -moz-transition: all ease 0.36s;
            transition: all ease 0.36s;
            background-repeat: no-repeat;
          }
        }
      }

      .list_one:hover .list_img_back {
        // transform: scale(1.05);
      }
      .list_one:hover .tooptipPart {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_list_photos/components/one_img.vue